import { format, parseISO } from 'date-fns'
import { ru } from 'date-fns/locale'

export const normalizeDate = (
  t: (key: string) => string,
  date: string | Date | undefined,
  withTime = false
) => {
  if (!date) {
    return t('unknown')
  }
  const datePattern = withTime ? 'dd.MM.yyyy HH:mm' : 'dd.MM.yyyy'
  if (date instanceof Date) {
    return format(date, datePattern)
  }
  return format(parseISO(date), datePattern, {
    locale: ru
  })
}

export const getUTCDate = (date?: Date) => {
  const d = date ? new Date(date) : new Date()
  const utcDate = new Date(
    d.getUTCFullYear(),
    d.getUTCMonth(),
    d.getUTCDate(),
    d.getUTCHours(),
    d.getUTCMinutes(),
    d.getUTCSeconds()
  )
  return utcDate
}

export const getMoscowDate = (date?: Date) => {
  const dt = date ? new Date(date) : new Date()
  return new Date(dt.valueOf() + dt.getTimezoneOffset() * 60 * 1000)
}

export const getDateWithMinues = (minutes: number) => {
  const nowDate = getMoscowDate()
  return new Date(nowDate.getTime() + minutes * 60000)
}
